<app-horaire-trajet [horaireTrajet]="aller" *ngIf="aller.isToday"></app-horaire-trajet>
<app-horaire-trajet [horaireTrajet]="retour" ></app-horaire-trajet>
<app-horaire-trajet [horaireTrajet]="aller" *ngIf="!aller.isToday"></app-horaire-trajet>
